import { createStore } from '@stencil/store';
import { UserForm } from '../utils/models';


interface State {
  checkoutId: string;
  checkoutStartLoading: boolean;
  checkoutCancelLoading: boolean;
  customFieldsForm: UserForm;
  customFieldsFormErrors: string[];
}

const { state } = createStore<State>({
  checkoutId: null,
  checkoutStartLoading: false,
  checkoutCancelLoading: false,
  customFieldsForm: {},
  customFieldsFormErrors: []
});

export { 
  state as checkout, 
};